import { FC } from 'react';
import { HorizontalPaddingLayout } from '@/HorizontalPaddingLayout';
import { Divider } from '@/components/Divider';
import { ConsultationCard } from '@/modules/invest/components/ConsultationCard';
import { Description, EfficiencyCompare, Specifications } from './components';
import { useFindFundByQuery } from '../../../../hooks/useFindFund';

export const LandingSection: FC = () => {
  const { fund } = useFindFundByQuery();

  return (
    <div>
      <HorizontalPaddingLayout className="gap-y-4 py-4">
        <Description />
        <Specifications />
      </HorizontalPaddingLayout>
      {fund?.fundHistory && (
        <>
          <Divider height={8} />
          <HorizontalPaddingLayout className="pt-6">
            <EfficiencyCompare />
          </HorizontalPaddingLayout>
        </>
      )}
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        <ConsultationCard />
      </HorizontalPaddingLayout>
    </div>
  );
};
